import axios from 'axios'
// import { useUserStore } from '@/stores/user' // 假设使用 Pinia 存储用户信息

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API+'/api/v1',
  //headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' ,"version":'1.0.0'},
  headers: { 'Content-Type': 'application/json;charset=UTF-8' ,"version":'1.0.0'},
  
  timeout: 15000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    let token = localStorage.getItem('haleon_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // 店铺来源：二维码入口 ?sid= 捕获后持久化，行为日志按店铺归属
    const storeCode = localStorage.getItem('store_code')
    if (storeCode) {
      config.headers['X-Store-Code'] = storeCode;
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    return res
    // 假设后端返回的数据格式为 { code, message, data }
    // if (res.code !== 200) {
    //   // 处理业务错误
    //   console.error('API Error:', res.message)
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res.data
    // }
  },
  error => {
    // 对响应错误做点什么
    console.log('err' + error) 
    // 处理 HTTP 错误
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 处理未授权
          break
        case 403:
          // 处理禁止访问
          break
        case 404:
          // 处理未找到
          break
        case 500:
          // 处理服务器错误
          break
      }
    }

    return Promise.reject(error)
  }
)

/**
 * 封装 GET 请求
 * @param {string} url 请求地址
 * @param {object} params 查询参数
 * @param {object} config axios 配置
 * @returns {Promise}
 */
export function get(url, params = {}, config = {}) {
  return service({
    method: 'get',
    url,
    params,
    ...config
  })
}

/**
 * 封装 POST 请求
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @param {object} config axios 配置
 * @returns {Promise}
 */
export function post(url, data = {}, config = {}) {
  return service({
    method: 'post',
    url,
    data,
    ...config
  })
}

/**
 * 封装 PUT 请求
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @param {object} config axios 配置
 * @returns {Promise}
 */
export function put(url, data = {}, config = {}) {
  return service({
    method: 'put',
    url,
    data,
    ...config
  })
}

/**
 * 封装 DELETE 请求
 * @param {string} url 请求地址
 * @param {object} params 查询参数
 * @param {object} config axios 配置
 * @returns {Promise}
 */
export function del(url, params = {}, config = {}) {
  return service({
    method: 'delete',
    url,
    params,
    ...config
  })
}

export default service
